var map = {
	"./evaluate0@2x.png": "fA2K",
	"./evaluate0_s@2x.png": "tFl3",
	"./evaluate1@2x.png": "g8Id",
	"./evaluate1_s@2x.png": "WAf5",
	"./evaluate2@2x.png": "o7Zg",
	"./evaluate2_s@2x.png": "AM6a"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fap+";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/evaluate.*@2x\.png$
// module id = fap+
// module chunks = 1